import { useChartColors } from './useChartColors';

/**
 * Hook to provide consistent axis styling for charts
 * Returns standardized axis props using theme-aware colors
 */
export const useChartAxis = () => {
  const chartColors = useChartColors();

  return {
    tick: { fill: chartColors.text, fontSize: 12 },
    tickLine: { stroke: chartColors.grid },
    axisLine: { stroke: chartColors.grid },
  };
};
